// Vision Era Construction logo — Chevron Mark variant
// variant: "full" (mark + wordmark) | "mark" (just chevrons) | "stacked"

const ORANGE = "#FF5A00";

export function ChevronMark({ className = "h-10 w-auto" }) {
  return (
    <svg viewBox="0 0 110 64" className={className} aria-hidden="true">
      <polygon points="0,56 32,12 56,12 24,56" fill={ORANGE} />
      <polygon points="32,56 64,12 84,12 52,56" fill={ORANGE} opacity="0.65" />
      <polygon points="62,56 92,12 104,12 74,56" fill={ORANGE} opacity="0.35" />
    </svg>
  );
}

export default function Logo({ variant = "full", className = "", showSubtitle = true }) {
  if (variant === "mark") {
    return <ChevronMark className={className || "h-10 w-auto"} />;
  }
  if (variant === "stacked") {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <ChevronMark className="h-10 w-auto" />
        <div className="leading-tight">
          <div
            className="font-display text-xl tracking-wider text-zinc-50"
            style={{ fontFamily: "Anton, Impact, sans-serif" }}
          >
            VISION ERA
          </div>
          {showSubtitle && (
            <div className="font-heading text-[10px] tracking-[0.3em] uppercase text-zinc-500">
              Construction
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <ChevronMark className="h-9 w-auto" />
      <div className="leading-tight hidden sm:block">
        <div
          className="font-display text-xl tracking-wider text-zinc-50"
          style={{ fontFamily: "Anton, Impact, sans-serif" }}
        >
          VISION ERA
        </div>
        {showSubtitle && (
          <div className="font-heading text-[10px] tracking-[0.3em] uppercase text-[#FF5A00]">
            Construction
          </div>
        )}
      </div>
    </div>
  );
}
